// Module
var code = "<span class=\"wifi-icon\" role=\"alert\" aria-live=\"assertive\" [attr.aria-label]=\"'go-recorder-status_slow_internet' | translate\" [matTooltip]=\"'go-recorder-status_slow_internet' | translate\" matTooltipPosition=\"above\"><i class=\"ficon-wifi-off\"></i></span>";
// Exports
module.exports = code;